import { SearchStringFilter } from 'components/SearchStringFilter';
import type { SelectedFilters } from 'uikit';

import { useCallback, useMemo, useState } from 'react';

import type { TFilters } from '../helpers';

export const useWorkOrderStructureFilters = () => {
    const [activeFilterValue, setActiveFilterValue] = useState<TFilters>();

    const colFilters = useMemo(
        () => [
            {
                id: 'codeWBS',
                field: 'codeWBS',
                name: 'Код',
                filterer: () => true,
                component: { name: SearchStringFilter },
            },
        ],
        [],
    );

    const additionalCols = useMemo(
        () => [
            {
                title: 'Код',
                accessor: 'codeWBS',
                width: 240,
            },
        ],
        [],
    );

    const onFiltersUpdated = useCallback((currentFilters: SelectedFilters) => {
        setActiveFilterValue({
            codeWBS: currentFilters?.codeWBS?.value,
        });
    }, []);

    return {
        colFilters,
        additionalCols,
        onFiltersUpdated,
        activeFilterValue,
    };
};
